import SlideUpModal from './SlideUpModal'

export default SlideUpModal
